import type { ComponentNameAndModule } from '@sitecore-jss/sitecore-jss-angular';

const loadChildren = () =>
  import('./feh-solar-panels.lazy.module').then(
    (module) => module.FehSolarPanelsLazyModule
  );

export const fehSolarPanelsLazyImports: ComponentNameAndModule[] = [
  {
    path: 'SolarPanelsWizard',
    loadChildren,
  },
  {
    path: 'SolarPanelsResultOverview',
    loadChildren,
  },
  {
    path: 'SolarPanelsResultOverviewSummary',
    loadChildren,
  },
];
